export const SUBMISSIONS_ROUTE = '/submissions';

export const CANCEL_SUBMISSION_ROUTE = `${SUBMISSIONS_ROUTE}/cancel`;
export const DRAFT_SUBMISSION_ROUTE = `${SUBMISSIONS_ROUTE}/draft`;
export const SUCCESS_SUBMISSION_ROUTE = `${SUBMISSIONS_ROUTE}/success`;
